import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import SingleTechnicianView from "./SingleTechnicianView";
import HomeComponent from "./HomeComponent";
// import Shift from "./Shift";
// import BranchClosure from "./BranchClosure";
// import Profile from "../UserProfile";
const managerRouting = ({ ...props }) => {
  return <Switch>
    <Route
      path={`${props.path}/:techssoId/techniciandetails`}
      component={SingleTechnicianView}
    />
    <Route path={`${props.path}/home`} render={() => <HomeComponent dateDataDown={props.dateData} dateDataUp={(dateData) => {
      props.dateDataUp(dateData)
    }} />} />
    {/* <Route path={`${match.path}/shift`} component={Shift} />
    <Route path={`${match.path}/branch`} component={BranchClosure} /> */}
    {/* <Route path={`${match.path}/profile`} component={Profile} /> */}
    <Route
      path={`${props.path}/:techssoId/profile`}
      render={() =>
        <Redirect to={`${props.path}/profile`} />
      }
    />
  </Switch>
}

export default managerRouting;
